import Cookies from "universal-cookie";

import { setupConstants } from "./constants";

var viewActions = require("../../store/view.actions");

var setupService = require("./api");

export const setupActions = {
  changeCurrentCalendar,
  getLevels,
  getSubjectLevels,
  deleteSubjectLevels,
  getUserDashboard,
  getKpis,
  getNewProfilePhotos,

  getCommits,
  getCollection,
  updateParameter,

  getEvaluations,
  updateEvaluation,
  createEvaluation,
  getSysUsers,
};

function getCollection(token, calendarID, endpoint) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getCollection", true));
    setupService
      .getCollection(token, calendarID, endpoint)

      .then((json) => {
        dispatch({
          type: setupConstants.GET_COLLECTION,
          collection: json,
        });
        dispatch(viewActions.isLoadingModule("getCollection", false));
      });
  };
}

function updateParameter(token, param_id, data, userID) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("updating_" + param_id, true));

    setupService.updateParameter(token, param_id, data).then((json) => {
      dispatch({
        type: setupConstants.UPDATE_PARAMETER,
        param_id: param_id,
        data: data,
        userID: userID,
      });
      dispatch(viewActions.isLoadingModule("updating_" + param_id, false));
    });
  };
}

function updateEvaluation(token, levelID, evaluationID, data, id) {
  return (dispatch) => {
    dispatch(
      viewActions.isLoadingModule("updating_" + evaluationID + id, true)
    );

    setupService
      .updateEvaluation(token, levelID, evaluationID, data)
      .then((json) => {
        dispatch({
          type: setupConstants.UPDATE_EVALUATION,
          evaluation_id: evaluationID,
          data: data,
        });
        dispatch(
          viewActions.isLoadingModule("updating_" + evaluationID + id, false)
        );
      });
  };
}

function createEvaluation(token, data) {
  return (dispatch) => {
    setupService.createEvaluation(token, data).then((json) => {
      dispatch({
        type: setupConstants.CREATE_EVALUATION,
        evaluation: json,
      });
    });
  };
}

function changeCurrentCalendar(calendarID) {
  let cookies = new Cookies();
  cookies.set("calID", calendarID, { path: "/" });
  window.location.reload();
}

function deleteSubjectLevels(token, levelID, subjectID) {
  return (dispatch) => {
    setupService.deleteSubjectLevels(token, levelID, subjectID).then((json) => {
      dispatch({
        type: setupConstants.SUBJECTS_LEVEL_DELETE,
        subject_id: subjectID,
      });
    });
  };
}

function getEvaluations(token, level) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getEvaluations", true));
    setupService.getEvaluations(token, level.level_id).then((json) => {
      dispatch({
        type: setupConstants.EVALUATIONS_LEVEL_LOAD,
        evaluations: json,
        level: level,
      });
      dispatch(viewActions.isLoadingModule("getEvaluations", false));
    });
  };
}
function getSubjectLevels(token, level) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getSubjectLevels", true));
    setupService.getSubjectLevels(token, level.level_id).then((json) => {
      dispatch({
        type: setupConstants.SUBJECTS_LEVEL_LOAD,
        subjects: json,
        level: level,
      });
      dispatch(viewActions.isLoadingModule("getSubjectLevels", false));
    });
  };
}

function getLevels(token, calendarID, parentID, lvlID) {
  return (dispatch) => {
    // dispatch(viewActions.isLoadingModule('getCourseTeachers',true)) ;
    setupService.getLevels(token, calendarID, parentID).then((json) => {
      dispatch({
        type: setupConstants.LEVEL_LOAD,
        // levels: json
        levels: json.map((c) => {
          return {
            value: c.level_id,
            label: c.name,
            type_id: c.type_id,
            level_id: c.level_id,
            name: c.name,
          };
        }),
        caller: lvlID,
      });
      // dispatch(viewActions.isLoadingModule('getCourseTeachers',false)) ;
    });
  };
}

function getCommits() {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getCommits", true));
    setupService.getCommits().then((json) => {
      dispatch({
        type: setupConstants.LOAD_COMMITS,
        commits: json,
      });
      dispatch(viewActions.isLoadingModule("getCommits", false));
    });
  };
}

function getKpis(token) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getKpis", true));
    setupService.getKpis(token).then((json) => {
      dispatch({
        type: setupConstants.LOAD_KPIS,
        kpis: json,
      });
      dispatch(viewActions.isLoadingModule("getKpis", false));
    });
  };
}

function getUserDashboard(token) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getUserDashboard", true));
    setupService.getUserDashboard(token).then((json) => {
      dispatch({
        type: setupConstants.LOAD_USER_DASHBOARD,
        userDashboardOjects: json,
      });
      dispatch(viewActions.isLoadingModule("getUserDashboard", false));
    });
  };
}

function getNewProfilePhotos(token) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getNewProfilePhotos", true));
    setupService.getNewProfilePhotos(token).then((json) => {
      dispatch({
        type: setupConstants.LOAD_NEW_PROFILE_PHOTOS,
        newProfilePhotos: json,
      });
      dispatch(viewActions.isLoadingModule("getNewProfilePhotos", false));
    });
  };
}

function getSysUsers(token) {
  return (dispatch) => {
    dispatch(viewActions.isLoadingModule("getSysUsers", true));

    setupService.getSysUsers(token).then((json) => {
      dispatch({
        type: setupConstants.GET_SYS_USERS,
        sysUsers: json,
      });
      dispatch(viewActions.isLoadingModule("getSysUsers", false));
    });
  };
}
